import React from 'react'

const Profile = () => {
    return (
        <div className="profiles-div" data-aos="fade-in" data-aos-duration="2000">
            <div className="profiles">
                <a href="https://www.hackerrank.com/sudheersid0710" target="_blank" rel="noreferrer"><button>Hackerrank</button></a>
                <a href="https://www.codechef.com/users/sudheer_07" target="_blank" rel="noreferrer"><button>Codechef</button></a>
                <a href="https://codeforces.com/profile/Code07hunt" target="_blank" rel="noreferrer"><button>Codeforces</button></a>
                <a href="https://leetcode.com/codeHunt07/"><button target="_blank" rel="noreferrer">LeetCode</button></a>
                <a href="https://github.com/ss0710"  target="_blank" rel="noreferrer"><button>Github</button></a>
                <a href="https://atcoder.jp/users/SidSingh"  target="_blank" rel="noreferrer"><button>Atcoder</button></a>
                <a href="https://auth.geeksforgeeks.org/user/sudheer07/practice/"  target="_blank" rel="noreferrer"><button>GFG</button></a>
            </div>
        </div>
    )
}

export default Profile
